<template>
  <div class="footer-widget">
    <section class="kc-elm kc-css-4360734 kc_row">
      <div class="befbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="befbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="aftbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="aftbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="befbgr5" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="befbgr6" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="aftbgr7" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="aftbgr8" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="kc-row-container kc-container">
        <div class="kc-wrap-columns">
          <div class="kc-elm kc-css-1949674 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
              <div class="kc-elm kc-css-4282031 kc_row kc_row_inner sst-flex-row-inner">
                <div class="kc-elm kc-css-740572 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                  <div class="kc_wrapper kc-col-inner-container">
                    <div class="ssc_mltttl kc-elm kc-css-2289599">
                      <h3 class="wr deb derb dea dera none nonea">
                        <span class="t1">{{ $t("footer.box1_title")}}</span>
                      </h3>
                    </div>
                    <div class="kc-elm kc-css-207586 kc_text_block">
                      <p>{{ $t("footer.box1_paragraph")}}</p>
                    </div>
                    <!-- <div class="ssc_icon_box kc-elm kc-css-1448524 template1">
                      <div class="icon_box">
                        <div class="bgr_no" style="width:8px; height:8px;">
                          <div></div>
                        </div>
                        <div
                          class="c_img"
                          style="margin-top: -8px; line-height:8px; height:8px; width:8px;"
                        >
                          <img
                            class="ls-is-cached lazyloaded"
                            data-src="../../assets/images/Marker.png"
                            alt="+1 963 542 78 32"
                            style="max-width: 8px; max-height: 8px;margin-top: calc((8px - 8px)/2);"
                            src="../../assets/images/Marker.png"
                          />
                        </div>
                      </div>
                      <div class="cont_box">
                        <div class="title">
                          <router-link to="/" :title="getSiteInfo.phone">{{getSiteInfo.phone}}</router-link>
                        </div>
                      </div>
                    </div>
                    <div class="ssc_icon_box kc-elm kc-css-2802498 template1">
                      <div class="icon_box">
                        <div class="bgr_no" style="width:8px; height:8px;">
                          <div></div>
                        </div>
                        <div
                          class="c_img"
                          style="margin-top: -8px; line-height:8px; height:8px; width:8px;"
                        >
                          <img
                            class="ls-is-cached lazyloaded"
                            data-src="../../assets/images/Marker.png"
                            :alt="getSiteInfo.email"
                            style="max-width: 8px; max-height: 8px;margin-top: calc((8px - 8px)/2);"
                            src="../../assets/images/Marker.png"
                          />
                        </div>
                      </div>
                      <div class="cont_box">
                        <div class="title">
                          <router-link to="/" :title="getSiteInfo.email">{{getSiteInfo.email}}</router-link>
                        </div>
                        <div class="description lines0">
                          <br />
                        </div>
                      </div>
                    </div>
                    <div class="kc-elm kc-css-2899979 kc_row kc_row_inner sst-flex-row-inner">
                      <div class="kc-elm kc-css-44976 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                        <div class="kc_wrapper kc-col-inner-container">
                          <div class="ssc_icon_box kc-elm kc-css-63307 template1">
                            <div class="icon_box">
                              <div class="bgr_no" style="width:8px; height:8px;">
                                <div></div>
                              </div>
                              <div
                                class="c_img"
                                style="margin-top: -8px; line-height:8px; height:8px; width:8px;"
                              >
                                <img
                                  class="ls-is-cached lazyloaded"
                                  data-src="../../assets/images/Marker.png"
                                  alt="Follow Us:"
                                  style="max-width: 8px; max-height: 8px;margin-top: calc((8px - 8px)/2);"
                                  src="../../assets/images/Marker.png"
                                />
                              </div>
                            </div>
                            <div class="cont_box">
                              <div class="title">{{ $t("follow_us")}}:</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="kc-elm kc-css-3020658 kc_col-sm-8 kc_column_inner kc_col-sm-8">
                        <div class="kc_wrapper kc-col-inner-container">
                          <div class="kc-elm kc-css-1062868 kc-multi-icons-wrapper">
                            <a
                              v-for="(network, index) in getSocialNetworks"
                              :key="index"
                              :href="network.url"
                              target="_blank"
                              title
                              :class="'multi-icons-link multi-icons' + network.icon"
                            >
                              <span></span>
                              <i :class="network.icon"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
                <div class="kc-elm kc-css-2877056 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                  <div class="kc_wrapper kc-col-inner-container">
                    <div class="ssc_mltttl kc-elm kc-css-1067417">
                      <h3 class="wr deb derb dea dera none nonea">
                        <span class="t1">{{ $t("footer.box2_title")}} {{ $t("footer.box22_title")}}</span>
                      </h3>
                    </div>
                    <div class="ssc_post_grid kc-elm kc-css-3740499 col1 items2 template9">
                      <div
                        class="grid"
                        data-ssc-grid-type="grid"
                        style="position: relative; height: 226px;"
                      >
                        <div
                          class="grid-item none"
                          style="position: absolute; left: 0px; top: 0px;"
                        >
                          <div class="pbody">
                            <div class="thumb"></div>
                            <div class="body">
                              <div class="meta">
                                <span class="date">
                                  <i class="far fa-clock"></i>
                                  <time
                                    class="entry-date"
                                    datetime="2020-04-12T13:40:00+00:00"
                                  >San Francisco, CA, USA</time>
                                </span>
                                <span class="updated">April 14th, 2020 06:59 am</span>
                              </div>
                              <div class="title">
                                <a
                                  href="#"
                                  class="lines2"
                                >77 Geary St 5th floor, San Francisco, CA 94018, United States</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="grid-item none"
                          style="position: absolute; left: 0px; top: 113px;"
                        >
                          <div class="pbody">
                            <div class="thumb"></div>
                            <div class="body">
                              <div class="meta">
                                <span class="date">
                                  <i class="far fa-clock"></i>
                                  <time
                                    class="entry-date"
                                    datetime="2020-01-31T17:45:15+00:00"
                                  >CABA, Buenos Aires, Argentina</time>
                                </span>
                                <span class="updated">March 20th, 2020 12:03 pm</span>
                              </div>
                              <div class="title">
                                <a
                                  href="#"
                                  class="lines2"
                                >Av. Corrientes 800, C1008 CABA, Argentina</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </div>
                </div>
                <div class="kc-elm kc-css-660449 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                  <div class="kc_wrapper kc-col-inner-container">
                    <div class="ssc_mltttl kc-elm kc-css-4015343">
                      <h3 class="wr deb derb dea dera none nonea">
                        <span class="t1">{{ $t("footer.box3_title")}}</span>
                      </h3>
                    </div>
                    <div class="kc-elm kc-css-2035853 kc_text_block">
                      <p>{{ $t("footer.box3_paragraph")}}</p>
                    </div>
                    <div class="ssc_icon_box kc-elm kc-css-1448524 template1">
                      <div class="icon_box">
                        <div class="bgr_no" style="width:8px; height:8px;">
                          <div></div>
                        </div>
                        <div
                          class="c_img"
                          style="margin-top: -8px; line-height:8px; height:8px; width:8px;"
                        >
                          <img
                            class="ls-is-cached lazyloaded"
                            data-src="../../assets/images/Marker.png"
                            alt="+1 963 542 78 32"
                            style="max-width: 8px; max-height: 8px;margin-top: calc((8px - 8px)/2);"
                            src="../../assets/images/Marker.png"
                          />
                        </div>
                      </div>
                      <div class="cont_box">
                        <div class="title">
                          <router-link to="/" :title="getSiteInfo.phone">{{getSiteInfo.phone}}</router-link>
                        </div>
                      </div>
                    </div>
                    <div class="ssc_icon_box kc-elm kc-css-2802498 template1">
                      <div class="icon_box">
                        <div class="bgr_no" style="width:8px; height:8px;">
                          <div></div>
                        </div>
                        <div
                          class="c_img"
                          style="margin-top: -8px; line-height:8px; height:8px; width:8px;"
                        >
                          <img
                            class="ls-is-cached lazyloaded"
                            data-src="../../assets/images/Marker.png"
                            :alt="getSiteInfo.email"
                            style="max-width: 8px; max-height: 8px;margin-top: calc((8px - 8px)/2);"
                            src="../../assets/images/Marker.png"
                          />
                        </div>
                      </div>
                      <div class="cont_box">
                        <div class="title">
                          <router-link to="/" :title="getSiteInfo.email">{{getSiteInfo.email}}</router-link>
                        </div>
                        <div class="description lines0">
                          <br />
                        </div>
                      </div>
                    </div>
                    <div class="kc-elm kc-css-2899979 kc_row kc_row_inner sst-flex-row-inner">
                      <div class="kc-elm kc-css-44976 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                        <div class="kc_wrapper kc-col-inner-container">
                          <div class="ssc_icon_box kc-elm kc-css-63307 template1">
                            <div class="icon_box">
                              <div class="bgr_no" style="width:8px; height:8px;">
                                <div></div>
                              </div>
                              <div
                                class="c_img"
                                style="margin-top: -8px; line-height:8px; height:8px; width:8px;"
                              >
                                <img
                                  class="ls-is-cached lazyloaded"
                                  data-src="../../assets/images/Marker.png"
                                  alt="Follow Us:"
                                  style="max-width: 8px; max-height: 8px;margin-top: calc((8px - 8px)/2);"
                                  src="../../assets/images/Marker.png"
                                />
                              </div>
                            </div>
                            <div class="cont_box">
                              <div class="title">{{ $t("follow_us")}}:</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="kc-elm kc-css-3020658 kc_col-sm-8 kc_column_inner kc_col-sm-8">
                        <div class="kc_wrapper kc-col-inner-container">
                          <div class="kc-elm kc-css-1062868 kc-multi-icons-wrapper">
                            <a
                              v-for="(network, index) in getSocialNetworks"
                              :key="index"
                              :href="network.url"
                              target="_blank"
                              title
                              :class="'multi-icons-link multi-icons' + network.icon"
                            >
                              <span></span>
                              <i :class="network.icon"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="ssc_caldf kc-elm kc-css-4334113">
                      <div
                        class="caldera-grid"
                        id="caldera_form_1"
                        data-cf-ver="1.8.7"
                        data-cf-form-id="CF5e4fd729e987a"
                      >
                        <div
                          id="caldera_notices_1"
                          data-spinner="../../assets/images/spinner.gif"
                        ></div>
                        <form
                          data-instance="1"
                          class="CF5e4fd729e987a caldera_forms_form cfajax-trigger _tisBound"
                          method="POST"
                          enctype="multipart/form-data"
                          id="CF5e4fd729e987a_1"
                          data-form-id="CF5e4fd729e987a"
                          aria-label="2 field subscribe"
                          data-target="#caldera_notices_1"
                          data-template="#cfajax_CF5e4fd729e987a-tmpl"
                          data-cfajax="CF5e4fd729e987a"
                          data-load-element="_parent"
                          data-load-class="cf_processing"
                          data-post-disable="0"
                          data-action="cf_process_ajax_submit"
                          data-hiderows="true"
                        >
                          <input
                            type="hidden"
                            id="_cf_verify_CF5e4fd729e987a"
                            name="_cf_verify"
                            value="5579525dd0"
                            data-nonce-time="1591598316"
                          />
                          <input type="hidden" name="_wp_http_referer" value="/about/" />
                          <div id="cf2-CF5e4fd729e987a_1"></div>
                          <input type="hidden" name="_cf_frm_id" value="CF5e4fd729e987a" />
                          <input type="hidden" name="_cf_frm_ct" value="1" />
                          <input type="hidden" name="cfajax" value="CF5e4fd729e987a" />
                          <input type="hidden" name="_cf_cr_pst" value="3487" />
                          <div class="hide" style="display:none; overflow:hidden;height:0;width:0;">
                            <label>Url</label>
                            <input type="text" name="url" value autocomplete="off" />
                          </div>
                          <div id="CF5e4fd729e987a_1-row-1" class="row first_row">
                            <div class="col-sm-12 single">
                              <div
                                data-field-wrapper="fld_9476759"
                                class="form-group"
                                id="fld_9476759_1-wrap"
                              >
                                <label
                                  id="fld_9476759Label"
                                  for="fld_9476759_1"
                                  class="control-label screen-reader-text sr-only"
                                >Email</label>
                                <div class>
                                  <input
                                    :placeholder="$t('footer.label_input')"
                                    required
                                    type="email"
                                    data-field="fld_9476759"
                                    class="form-control"
                                    id="fld_9476759_1"
                                    name="fld_9476759"
                                    value
                                    data-type="email"
                                    aria-required="true"
                                    aria-labelledby="fld_9476759Label"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id="CF5e4fd729e987a_1-row-2" class="row last_row">
                            <div class="col-sm-12 single">
                              <div
                                data-field-wrapper="fld_1739855"
                                class="form-group"
                                id="fld_1739855_1-wrap"
                              >
                                <div class>
                                  <input
                                    class="btn btn-default"
                                    type="submit"
                                    name="fld_1739855"
                                    id="fld_1739855_1"
                                    :value="$t('footer.label_button')"
                                    data-field="fld_1739855"
                                  />
                                </div>
                              </div>
                              <input
                                class="button_trigger_1"
                                type="hidden"
                                name="fld_1739855"
                                id="fld_1739855_1_btn"
                                value
                                data-field="fld_1739855"
                              />
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="ssc_searchf kc-elm kc-css-1439105">
                      <form
                        role="search"
                        method="get"
                        class="search-form"
                        action="https://globaldev.io/"
                      >
                        <label>
                          <span class>Search Form</span>
                        </label>
                        <input
                          type="search"
                          class="search-field"
                          placeholder="Enter Query"
                          value
                          name="s"
                          title="Enter Query"
                        />
                        <button type="submit" class="search-submit">
                          <span>
                            <i class="fa-leaf"></i>
                          </span> Search
                        </button>
                      </form>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      data-kc-equalheight="true"
      data-kc-equalheight-align="middle"
      class="kc-elm kc-css-3914937 kc_row"
    >
      <div class="befbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim="none"></div>
      <div class="befbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim="none"></div>
      <div class="aftbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim="none"></div>
      <div class="aftbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim="none"></div>
      <div class="befbgr5" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="befbgr6" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="aftbgr7" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="aftbgr8" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="kc-row-container kc-container">
        <div class="kc-wrap-columns">
          <div class="kc-elm kc-css-3640123 kc_col-sm-8 kc_column kc_col-sm-8">
            <div class="kc-col-container">
              <div class="kc-elm kc-css-3141476 kc_text_block">
                <p v-html="$t('footer.copyright')"></p>
              </div>
            </div>
          </div>
          <div class="kc-elm kc-css-3332474 kc_col-sm-4 kc_column kc_col-sm-4">
            <div class="kc-col-container">
              <div class="kc-elm kc-css-4235042 kc_text_block">
                <p>
                  <router-link to="/privacy-policy">{{ $t("privacy_policy")}}</router-link>&nbsp; &nbsp; &nbsp;|&nbsp; &nbsp; &nbsp;
                  <router-link to="/terms">{{ $t("terms")}}</router-link>
                  <small> > BuildVersion {{ getBuildVersion }} </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vuex from "vuex";
export default {
  name: "Footer",
  data() {
    return {
      msg: "Footer"
    };
  },
  computed: {
    ...Vuex.mapGetters(["getSiteInfo", "getSocialNetworks", "getBuildVersion"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue